import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from '../components/search/search.component';
import { SnackComponent } from '../components/snack/snack.component';
import { NumberFormatPipe } from '../pipes/number-format/NumberFormat.pipe';
import { DisplayErrorsMessageModule } from '../tinea-components/display-errors-message/display-errors-message.module';
import { FileDownloadComponent } from '../tinea-components/file-download/file-download.component';
import { FileUploadComponent } from '../tinea-components/file-upload/file-upload.component';
import { LoadingModule } from '../tinea-components/loading/loading.module';
import { CollapseComponent } from './components/collapse/collapse.component';
import { ErrorComponent } from './components/error/error.component';
import { FiltersTableComponent } from './components/filters-table/filters-table.component';
import { HeaderComponent } from './components/header/header.component';
import { AlertComponent } from './components/notifications/alert/alert.component';
import { InputRestrictionDirective } from './directives/input-number.directive';
import { TogglePasswordDirective } from './directives/toggle-password.directive';
import { BasicConfirmModalComponent } from './components/dialog/basic-confirm-modal/basic-confirm-modal.component';
import { DeliveryCommentComponent } from './components/delivery-comments/delivery-comment.component';
import {ButtonComponent} from './components/split-button/button.component';

@NgModule({
  declarations: [
    HeaderComponent,
    AlertComponent,
    ErrorComponent,
    FiltersTableComponent,
    FileDownloadComponent,
    FileUploadComponent,
    TogglePasswordDirective,
    CollapseComponent,
    NumberFormatPipe,
    SearchComponent,
    SnackComponent,
    InputRestrictionDirective,
    BasicConfirmModalComponent,
    DeliveryCommentComponent
  ],
    imports: [
        CommonModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatButtonToggleModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatChipsModule,
        RouterModule,
        LoadingModule,
        TranslateModule,
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        DisplayErrorsMessageModule,
        MatTooltipModule,
        MatNativeDateModule,
        MatSelectModule,
        MatFormFieldModule,
        MatSnackBarModule,
        ButtonComponent,
    ],
  exports: [
    HeaderComponent,
    AlertComponent,
    MatDialogModule,
    ErrorComponent,
    FiltersTableComponent,
    FileDownloadComponent,
    FileUploadComponent,
    TogglePasswordDirective,
    CollapseComponent,
    NumberFormatPipe,
    SearchComponent,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    SnackComponent,
    MatSnackBarModule,
    MatTabsModule,
    InputRestrictionDirective,
    MatTooltipModule,
    BasicConfirmModalComponent,
    DeliveryCommentComponent
  ],
})
export class SharedModule {}
